import { Box, Typography, styled, Button, ButtonProps } from "@mui/material";
import AssistantCardList from "./AssistantCard";
import UseCaseSelectorCard from "./UseCaseSelectorCard";
import { useTranslation } from "react-i18next";
import grafik_aufgabenbereich from "assets/images/grafik_aufgabenbereich.png";
import grafik_branche from "assets/images/grafik_branche.png";
import { useNavigate } from "react-router-dom";

const Container = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1440px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  gap: "2rem",
  padding: "0 1rem",
}));

const ScrollContainer = styled(Box)(() => ({
  width: "100%",
  overflowX: "auto",
  paddingBottom: "0.5rem",
  "&::-webkit-scrollbar": {
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#bbb",
    borderRadius: "4px",
  },
}));

const Row = styled(Box)(() => ({
  display: "flex",
  gap: "1.5rem",
  width: "fit-content",
  padding: "0.5rem",
}));

const StyledButton = styled(Button)<ButtonProps>(() => ({
  marginTop: "2rem",
  padding: "0.6rem 2rem",
  backgroundColor: "#a1b7a5",
  color: "white",
  fontSize: "1.1rem",
  fontWeight: "bold",
  textTransform: "none",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: "#8fa895",
  },
}));

const AvatarSelectionCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateToSkillary = () => {
    navigate("/skillary"); 
  };

  return (
    <Container>
      <ScrollContainer>
        <Row>
          <AssistantCardList />
        </Row>
      </ScrollContainer>

      <Typography variant="h5" sx={{ fontWeight: 700, fontSize: "2rem", color: "#002E5A" }}>
        {t("selectUseCaseDescription")}
      </Typography>

      <Box display="flex" gap="2rem" flexWrap="wrap" justifyContent="center">
        <UseCaseSelectorCard
          id="usecase-function"
          title={t("Function Selection")}
          imageSrc={grafik_aufgabenbereich}
          options={["Others", "Sales", "Marketing", "Accounting", "HR", "Procurement", "IT"]}
        />

        <UseCaseSelectorCard
          id="usecase-industry"
          title={t("Industry Selection")}
          imageSrc={grafik_branche}
          options={[
            "Software/ICT", "Engineering", "Chemistry/Pharma",
            "Banking/Insurance", "Logistics", "Retail", "Energy"
          ]}
        />
      </Box>
      
      <StyledButton onClick={handleNavigateToSkillary}>
        {t("Go to Skillary")}
      </StyledButton>
    </Container>
  );
};

export default AvatarSelectionCard;
